import GiftCardSelectionComponent from 'src/components/GiftCardsSelection/gift-card-selection';

const SelectGiftCardPage: React.FC = () => {
  return <GiftCardSelectionComponent />;
};

//@todo: remove this function once this is safely in prod as it's just a feature flag
export const getServerSideProps = async () => {
  if (!process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY) {
    return {
      notFound: true,
    };
  }
  return {
    props: {},
  };
};

export default SelectGiftCardPage;
